import React from 'react'
import { LeadDesign } from '../../model/ModelAddUpdateDesign';
import Const from '../../../util/Constants';
import Display from '../../../util/Display';

class DetailTab extends React.Component {
  constructor(props) {
    super(props);

    this.Design = [];
    this.state = {
      propertyName: '',
    };

    if (props.model?.fields) {
      this.setDesign(props.model.fields, LeadDesign);
    }
  }

  componentDidMount() {
    this.loadPropertyName(this.props.lead);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lead?.id !== this.props.lead?.id) {
      this.loadPropertyName(this.props.lead);
      this.Design = [];
      this.setDesign(this.props.model.fields, LeadDesign);
    }
  }

  loadPropertyName = async (lead) => {
    if (!lead?.property) {
      this.setState({ propertyName: '' });
      return;
    }

    try {
      const propertyName = await this.getPropertyName(lead.property);
      this.setState({ propertyName });
    } catch {
      this.setState({ propertyName: '-' });
    }
  };

  getPropertyName = async (propertyIds) => {
    let ids =
      propertyIds && propertyIds !== '~~'
        ? propertyIds.substring(1, propertyIds.length - 1).split(Const.Opt)
        : [];

    const names = [];
    for (let i = 0; i < ids.length; i++) {
      const name = await Display.getPropertyName(parseInt(ids[i]));
      if (name) names.push(name);
    }
    return names.join(', ');
  };

  setDesign = (fields, Design) => {
    if (!fields) return;

    const maxOrder = Math.max(...Design.map(d => d.order));
    const AdditionalFields = {
      order: maxOrder + 1,
      title: 'Additional Information',
      fields: [],
    };

    Object.keys(fields).forEach(key => {
      const exists = Design.find(d => d.fields.includes(key));
      if (!exists) AdditionalFields.fields.push(key);
    });

    this.Design = [...Design, AdditionalFields].sort(
      (a, b) => a.order - b.order
    );
  };

  renderValue = (fieldKey) => {
    if (fieldKey === 'property') {
      return this.state.propertyName || '-';
    }
    return Display.FieldValue(
      this.props.lead,
      fieldKey,
      this.props.model.fields
    );
  };

  render() {
    const { model } = this.props;

    return (
      <div style={{ marginTop: 20 }}>
        {this.Design.map((section, index) => (
          <div
            key={index}
            style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              paddingInline: "8px",
              paddingBottom: '14px',
              marginBottom: '24px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
          >
            {/* Header — SAME NEW UI */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '24px',
                paddingBottom: '16px',
                borderBottom: '2px solid #f3f4f6',
              }}
            >
              <div
                style={{
                  backgroundColor: '#3b82f6',
                  width: '4px',
                  height: '24px',
                  borderRadius: '2px',
                  marginRight: '12px',
                }}
              />
              <h4
                style={{
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#111827',
                  margin: 0,
                }}
              >
                {section.title}
              </h4>
            </div>

            {/* Fields — SAME NEW GRID UI */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '20px',
              }}
            >
              {section.fields.map(fieldKey =>
                model.fields[fieldKey]?.visible ? (
                  <div key={fieldKey}>
                    <div
                      style={{
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#6b7280',
                        marginBottom: '6px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                      }}
                    >
                      {model.fields[fieldKey].label_name}
                    </div>
                    <div
                      style={{
                        fontSize: '15px',
                        fontWeight: '600',
                        color: '#111827',
                      }}
                    >
                      {this.renderValue(fieldKey)}
                    </div>
                  </div>
                ) : null
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default DetailTab